"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPrefix = setPrefix;
exports.hexToStr = hexToStr;
exports.watchTx = watchTx;
exports.base58 = void 0;

var _baseX = _interopRequireDefault(require("base-x"));

var _web3Utils = _interopRequireDefault(require("web3-utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BASE58 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var base58 = (0, _baseX["default"])(BASE58);
exports.base58 = base58;

function setPrefix(hash) {
  return _web3Utils["default"].soliditySha3({
    type: "bytes",
    value: _web3Utils["default"].stringToHex("\x19Ethereum Signed Message:\n32")
  }, {
    type: "bytes",
    value: hash
  });
}

function hexToStr(hex) {
  var bytes = _web3Utils["default"].hexToBytes(hex);

  return base58.encode(Buffer.from(bytes)).toString("utf8");
}

function watchTx(web3, tx) {
  var transactionReceiptAsync = function transactionReceiptAsync(resolve, reject) {
    web3.eth.getTransactionReceipt(tx, function (error, receipt) {
      if (error) {
        reject(error);
      } else if (receipt === null || receipt.status === "0x1" && receipt.blockNumber === null) {
        setTimeout(function () {
          transactionReceiptAsync(resolve, reject);
        }, 5000);
      } else {
        resolve(receipt);
      }
    });
  };

  if (Array.isArray(tx)) {
    return Promise.all(tx.map(function (oneTx) {
      return watchTx(web3, oneTx);
    }));
  } else if (typeof tx === "string") {
    return new Promise(transactionReceiptAsync);
  }

  throw new Error("Invalid Type: ".concat(tx));
}